/**
 * Player identity and the TV's display token live in localStorage so a phone or TV that
 * reloads comes back as itself without help from the host.
 */

const playerKey = (code: string) => `pbt:player:${code.toUpperCase()}`;
const displayKey = (code: string) => `pbt:display:${code.toUpperCase()}`;

export interface StoredPlayer {
  token: string;
  name: string;
}

export function loadPlayer(code: string): StoredPlayer | null {
  try {
    const raw = localStorage.getItem(playerKey(code));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredPlayer;
    return parsed.token ? parsed : null;
  } catch {
    return null;
  }
}

export function savePlayer(code: string, player: StoredPlayer): void {
  try {
    localStorage.setItem(playerKey(code), JSON.stringify(player));
  } catch {
    // Private browsing with storage disabled: the player just re-enters a name.
  }
}

export function clearPlayer(code: string): void {
  try {
    localStorage.removeItem(playerKey(code));
  } catch {
    /* ignore */
  }
}

/** The TV's credential for one session, from the link's `?t=`, kept so it is needed once. */
export function loadDisplayToken(code: string): string {
  try {
    return localStorage.getItem(displayKey(code)) ?? '';
  } catch {
    return '';
  }
}

export function saveDisplayToken(code: string, token: string): void {
  try {
    localStorage.setItem(displayKey(code), token);
  } catch {
    // Storage disabled: the TV keeps working on the URL, since nothing navigates away.
  }
}
